import React, { useCallback, useEffect, useState } from "react";
import api from "../Services/api";
import CurrencyInput, { CurrencyInputProps } from 'react-currency-input-field';
import './main.css';
import ChartIR from "./ChartIR";
import axios from "axios";

interface Data {
	[key: string]: PlanoData;
}

interface Faixa {
	ID: number;
	Ordem: number,
	Ate: number;
	Taxa: number;
	Deducao: number;
	De?: number;
	Plano: string;
}

interface PlanoData {
	Faixas: Faixa[];
	ValorContribuicaoMensal?: number;
}

interface IData { name: string; contrib: number; restante: number; total: number; }

const CalculadorDeduzirIRComp = () => {

	// const mockFaixas: Faixa[] = [
	// 	{
	// 		"ID": 1,
	// 		"Ordem": 1,
	// 		"Ate": 2548.22,
	// 		"Taxa": 3.6,
	// 		"Deducao": 0,
	// 		"Plano": "PlanoB"
	// 	},
	// 	{
	// 		"ID": 2,
	// 		"Ordem": 2,
	// 		"Ate": 5096.43,
	// 		"Taxa": 6,
	// 		"Deducao": 61.16,
	// 		"Plano": "PlanoB"
	// 	},
	// 	{
	// 		"ID": 3,
	// 		"Ordem": 3,
	// 		"Ate": 15289.29,
	// 		"Taxa": 11.99,
	// 		"Deducao": 366.44,
	// 		"Plano": "PlanoB"
	// 	},
	// 	{
	// 		"ID": 4,
	// 		"Ordem": 4,
	// 		"Ate": 0,
	// 		"Taxa": 14.39,
	// 		"Deducao": 733.38,
	// 		"Plano": "PlanoB"
	// 	},
	// 	{
	// 		"ID": 5,
	// 		"Ordem": 1,
	// 		"Ate": 7870.34,
	// 		"Taxa": 3,
	// 		"Deducao": 0,
	// 		"Plano": "PlanoTaesa"
	// 	},
	// 	{
	// 		"ID": 6,
	// 		"Ordem": 2,
	// 		"Ate": 15740.68,
	// 		"Taxa": 6,
	// 		"Deducao": 236.11,
	// 		"Plano": "PlanoTaesa"
	// 	},
	// 	{
	// 		"ID": 7,
	// 		"Ordem": 3,
	// 		"Ate": 0,
	// 		"Taxa": 12,
	// 		"Deducao": 1180.55,
	// 		"Plano": "PlanoTaesa"
	// 	},
	// ]

	// const mock = { data: { results: mockFaixas } };

	const [planoEscolhido, setPlanoEscolhido] = useState("PlanoB");
	const [remuneracao, setRemuneracao] = useState(0);
	const [outrosRend, setOutrosRend] = useState(0);
	const [loading, setLoading] = useState(false);
	const [rawValue, setRawValue] = useState<string | undefined>(' ');
	const [faixaDePerDeContribuicao, setFaixaDePerDeContribuicao] = useState<IData[]>([]);


	const ensureFaixas = (faixas: Faixa[]): void => {

		if (faixas && faixas.length > 0) {

			let faixaAnterior: Faixa | null = null;

			for (let index = 0; index < faixas.length; index++) {
				const faixa = faixas[index];
				// primeira faixa
				if (faixa.Ordem === 1) {
					faixa.De = 0;
				}
				// faixas intermediarias
				else {
					faixaAnterior = faixas[index - 1];
					faixa.De = faixaAnterior.Ate + 0.01;
				}
			}
		}
	}

	const calculaValorDeContribuicaoMensal = (remuneracaoMensal: number, plano: PlanoData, index = 0): void => {
		const faixas: Faixa[] = plano.Faixas;

		if (index >= faixas.length) {
			const ultimo = faixas[faixas.length - 1];
			plano.ValorContribuicaoMensal = parseFloat((remuneracaoMensal * (ultimo.Taxa / 100) - (ultimo.Deducao ?? 0)).toFixed(2));
			return;
		}

		const item = faixas[index];

		// Se deduzIR for menor ou igual ao limite 'Ate', aplica a fórmula e retorna
		if (remuneracaoMensal <= item.Ate) {
			plano.ValorContribuicaoMensal = parseFloat((remuneracaoMensal * (item.Taxa / 100) - (item.Deducao ?? 0)).toFixed(2));
			return;
		}

		// Chama recursivamente com o próximo item da lista
		return calculaValorDeContribuicaoMensal(remuneracaoMensal, plano, index + 1);
	}

	function getValoMaxBeneficioFiscal(remuneracao: number, outrosRend: number, faixaIsentaIRAnual: number, contribuicaoAnualAoPlano: number) {
		if ((remuneracao + outrosRend) * 12 < faixaIsentaIRAnual) {
			return 0;
		}
		else if (remuneracao + outrosRend < 0/*$DeduzIR.$AC$14*/) {
			return 0; //$DeduzIR.$AC$11
		}
		else if (
			((((remuneracao * 12 + outrosRend * 12) * 0.12) - contribuicaoAnualAoPlano)) > 0) {
			return ((remuneracao * 12 + outrosRend * 12) * 0.12) - contribuicaoAnualAoPlano
		}
		else {
			return 0; //$DeduzIR.$AC$10
		}
	}

	function getAproveitamentoMaxBeneficioFiscal(remuneracao: number, outrosRend: number, faixaIsentaIRAnual: number) {
		if ((remuneracao + outrosRend) * 12 < faixaIsentaIRAnual) {
			return 0 * 12 * 0.12;
		}
		else {
			return (remuneracao + outrosRend) * 12 * 0.12
		}
	}

	useEffect(() => {
		setLoading(false);
	}, [])


	const getFaixaPerContribuicao = (base: number, faixaIsentaIRAnual: number) => {
		return [
			{
				"name": "50%",
				"contrib": base * 0.50,
				"restante": getValoMaxBeneficioFiscal(remuneracao, outrosRend, faixaIsentaIRAnual, base * 0.50),
				"total": getAproveitamentoMaxBeneficioFiscal(remuneracao, outrosRend, faixaIsentaIRAnual)
			},
			{
				"name": "75%",
				"contrib": base * 0.75,
				"restante": getValoMaxBeneficioFiscal(remuneracao, outrosRend, faixaIsentaIRAnual, base * 0.75),
				"total": getAproveitamentoMaxBeneficioFiscal(remuneracao, outrosRend, faixaIsentaIRAnual)
			},
			{
				"name": "90%",
				"contrib": base * 0.9,
				"restante": getValoMaxBeneficioFiscal(remuneracao, outrosRend, faixaIsentaIRAnual, base * 0.9),
				"total": getAproveitamentoMaxBeneficioFiscal(remuneracao, outrosRend, faixaIsentaIRAnual)
			},
			{
				"name": "100%",
				"contrib": base,
				"restante": getValoMaxBeneficioFiscal(remuneracao, outrosRend, faixaIsentaIRAnual, base * 1),
				"total": getAproveitamentoMaxBeneficioFiscal(remuneracao, outrosRend, faixaIsentaIRAnual)
			},
			{
				"name": "125%",
				"contrib": base * 1.25,
				"restante": getValoMaxBeneficioFiscal(remuneracao, outrosRend, faixaIsentaIRAnual, base * 1.25),
				"total": getAproveitamentoMaxBeneficioFiscal(remuneracao, outrosRend, faixaIsentaIRAnual)
			},
			{
				"name": "150%",
				"contrib": base * 1.5,
				"restante": getValoMaxBeneficioFiscal(remuneracao, outrosRend, faixaIsentaIRAnual, base * 1.5),
				"total": getAproveitamentoMaxBeneficioFiscal(remuneracao, outrosRend, faixaIsentaIRAnual)
			},
			{
				"name": "200%",
				"contrib": base * 2,
				"restante": getValoMaxBeneficioFiscal(remuneracao, outrosRend, faixaIsentaIRAnual, base * 2),
				"total": getAproveitamentoMaxBeneficioFiscal(remuneracao, outrosRend, faixaIsentaIRAnual)
			},
		];
	}

	/**
	 * Verifica se o retorno da configuracao do backend esta correto
	 * @param configuracoesPortal 
	 * @returns 
	 */
	const getConfigValue = (configuracoesPortal: any, parametroConfiguracao: string) => {

		if (configuracoesPortal?.results?.length === 0) {
			throw new Error("Nenhum dado encontrado para o parâmetro: " + parametroConfiguracao);
		}
		const configItem = configuracoesPortal?.results[0];
		if (!configItem) {
			throw new Error("Nenhum dado encontrado para o parâmetro: " + parametroConfiguracao);
		}
		const configValor = configItem['Valor'];

		return parseFloat(configValor.replace(',', '.'));
	}

	/**
	 * Envia requisicao para o backend calcular os aportes
	 */
	const calcularDeduzirIR = useCallback(() => {

		const parametroConfiguracao = 'Calculadora DeduzirIR - Faixa Isenta IR Mensal'

		axios.all([
			api.get("/ObterDadosCalDeduzir"),
			api.get(`/ObterConfiguracoesPortal?parametro=${parametroConfiguracao}`),
		])
			.then(axios.spread((deduzirResponse, configuracoesResponse) => {
				const dadosDeduzir = deduzirResponse.data;
				const configuracoesPortal = configuracoesResponse.data;

				// Faixa isenta de IR Mensal
				const faixaIsentaIRMensal = getConfigValue(configuracoesPortal, parametroConfiguracao); // 2259.21;

				// Faixa isenta de IR Anual
				const faixaIsentaIRAnual = faixaIsentaIRMensal * 12;

				const dataLocal: Data = {};

				dadosDeduzir?.results?.forEach((item: Faixa) => {
					const plano = item.Plano;

					if (!dataLocal[plano]) {
						dataLocal[plano] = { Faixas: [] };
					}

					dataLocal[plano].Faixas.push(item);
				});

				ensureFaixas(dataLocal[planoEscolhido].Faixas);

				calculaValorDeContribuicaoMensal(remuneracao, dataLocal[planoEscolhido]);

				const base = (dataLocal[planoEscolhido]?.ValorContribuicaoMensal ?? 0) * 12;

				const faixaDePerDeContribuicao = getFaixaPerContribuicao(base, faixaIsentaIRAnual)
				setFaixaDePerDeContribuicao(faixaDePerDeContribuicao);


			}))
			.catch((err) => {
				throw new Error(err);
			});

	}, [planoEscolhido, remuneracao, outrosRend]);


	/**
	 * Controla os valores digitados na remuneracao
	 * @param value 
	 * @param _ 
	 * @param values 
	 */
	const handleOnValueChange: CurrencyInputProps['onValueChange'] = (value, _, values): void => {
		setRawValue(value === undefined ? 'undefined' : value || ' ');
		setRemuneracao(Number(rawValue?.replace(/,/g, '.')));
	};

	const handleOnValueOutrosRendChange: CurrencyInputProps['onValueChange'] = (value, _, values): void => {
		setOutrosRend(Number(value?.replace(/,/g, '.')));
	};

	/**
	 * Valida os valores da remuneracao e limpa a tabela de resultado caso remuneracao vaiza
	 * @param event Evento
	 */
	const handleOnKeyUp = (event: React.KeyboardEvent<HTMLInputElement>): void => {

		if (!event.currentTarget.value) {
			setRawValue('');
			setRemuneracao(0);
		}
	}

	const handleOutrosRendOnKeyUp = (event: React.KeyboardEvent<HTMLInputElement>): void => {

		if (!event.currentTarget.value) {
			setOutrosRend(0)
		}
	}

	useEffect(() => {
		setFaixaDePerDeContribuicao([]);
	}, [planoEscolhido, remuneracao, outrosRend])

	return (
		<>
			<div className="d-flex col-3 col-md-2 col-lg-1 justify-content-center">

			</div>
			<div className="card calc">
				<div className="card-body">

					<div className="col-md-12" id="inputs" style={{ minWidth: "100%", position: "relative" }}>
						<div style={{ width: "100%", overflow: "hidden" }}>
							<div className="col-md-4" style={{ float: "left", width: "100%" }}>
								<label className="mb-2">Plano</label>
								<div style={{ paddingBlock: "1px" }} className="deduzirir">
									<select value={planoEscolhido} onChange={(e) => { setPlanoEscolhido((e.target.value)) }} style={{ border: "1px solid #ccc" }} className="form-control pula" disabled={loading}>
										<option value='PlanoB'>Plano B</option>
										<option value='PlanoTaesa'>Plano Taesaprev</option>
									</select>
								</div>

							</div>

							<div className="col-md-4" style={{ float: "left", width: "100%" }}>
								<label className="mb-2" htmlFor="ctrlRemuneracao">Remuneração mensal</label>
								<div style={{ paddingBlock: "1px" }} className="deduzirir">

									<CurrencyInput
										disabled={loading}
										id="ctrlRemuneracao"
										name="ctrlRemuneracao"
										style={{ border: "1px solid #ccc" }}
										className="form-control pula"
										placeholder="R$ 0,00"
										// defaultValue={1000}
										groupSeparator={'.'}
										decimalSeparator={','}
										decimalScale={2}
										intlConfig={{ locale: 'pt-BR', currency: 'BRL' }}
										onValueChange={handleOnValueChange}
										onKeyUp={handleOnKeyUp}
									/>

								</div>
							</div>
							<div className="col-md-4" style={{ float: "left", width: "100%" }}>
								<label className="mb-2" htmlFor="ctrlOutrosRend">Outros Rendimentos Mensais Tributáveis</label>
								<div style={{ paddingBlock: "1px" }} className="deduzirir">

									<CurrencyInput
										disabled={loading}
										id="ctrlOutrosRend"
										name="ctrlOutrosRend"
										style={{ border: "1px solid #ccc" }}
										className="form-control pula"
										placeholder="R$ 0,00"
										// defaultValue={1000}
										groupSeparator={'.'}
										decimalSeparator={','}
										decimalScale={2}
										intlConfig={{ locale: 'pt-BR', currency: 'BRL' }}
										onValueChange={handleOnValueOutrosRendChange}
										onKeyUp={handleOutrosRendOnKeyUp}
									/>

								</div>
							</div>
							<div className="col-md-6 calc1">
								<br />
								<div className="calc2">
									<input type="submit"
										id="botaoEnviar" className="btn" style={{ backgroundColor: "#d6740d", color: "#fff", position: 'relative', minWidth: "120px", height: "44px" }}
										value="Calcular"
										disabled={loading || (!remuneracao)} onClick={(e) => { calcularDeduzirIR() }} />
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<br />
			<br />
			{(faixaDePerDeContribuicao && faixaDePerDeContribuicao.length > 0 && (remuneracao > 0 || outrosRend > 0)) &&
				<>
					<ChartIR
						data={faixaDePerDeContribuicao}
						plano={planoEscolhido}
						remuneracao={remuneracao}
						outrosRend={outrosRend}>
					</ChartIR>
				</>}
		</>
	)
};
export default CalculadorDeduzirIRComp


